export const CART_URL =
  'https://mealprepclub.shop/cart/add?id=57676985106814&quantity=1'
